import type { TSeat } from '@core/types';

/** 補花圖示播放期間暫存該家的 action，圖示完成後才交還 scene 處理。 */
export class CFlowerTurnGate<TAction> {
  private readonly activeCounts = new Map<TSeat, number>();
  private readonly pendingActions = new Map<TSeat, TAction>();

  begin(seat: TSeat): void {
    const activeCount = this.activeCounts.get(seat) ?? 0;
    this.activeCounts.set(seat, activeCount + 1);
    if (activeCount === 0) this.pendingActions.delete(seat);
  }

  hold(seat: TSeat, action: TAction): boolean {
    if (!this.activeCounts.has(seat)) return false;
    this.pendingActions.set(seat, action);
    return true;
  }

  complete(seat: TSeat): TAction | null {
    const activeCount = this.activeCounts.get(seat) ?? 0;
    if (activeCount > 1) {
      this.activeCounts.set(seat, activeCount - 1);
      return null;
    }
    this.activeCounts.delete(seat);
    const action = this.pendingActions.get(seat) ?? null;
    this.pendingActions.delete(seat);
    return action;
  }

  isWaiting(): boolean {
    return this.activeCounts.size > 0;
  }

  cancel(): void {
    this.activeCounts.clear();
    this.pendingActions.clear();
  }
}
